import {useState, useEffect} from 'react';
import {Image} from '@shopify/hydrogen';

export function LazyImage(props) {
  const {src, width, height, alt, className} = props;
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 300);
  }, []);

  return (
    <div className={className}>
      {!isLoaded ? (
        <Image
          src={src}
          width={width}
          height={height}
          alt={alt}
          className={`${className} blur-md animate-pulse`}
        />
      ) : (
        <Image
          src={src}
          width={width}
          height={height}
          alt={alt}
          className={className}
        />
      )}
    </div>
  );
}
